import { NgModule } from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ExcelExportService } from './http';

import {
  RdoHttpService,
  AuthService,
  ConfigService,
  RevenueChartHelperService,
  FormatService,
  QueryService,
  SvgService,
  ViewService,
  ActiveFilterService,
  ProfileService,
  ClientProfileService,
  ColumnDefinitionService,
  GridConfigService,
  RevenueMappingService,
  BreadcrumbService,
  LocaleService,
  RentalGrowthChartService,
  RentalGrowthPanelEventService,
  DailyRatesChartService,
  HourlyRatesChartService,
  DollarUtilChartService,
  MonthlyRatesChartService,
  PhysicalUtilChartService,
  UnitsOnRentChartService,
  WeeklyRatesChartService,
  UnitsInFleetChartService,
  ChartExportService,
  MathService,
  ErrorService,
  FirestoreSettingsService,
  GridSortingService,
  TrialGuardService,
  LanguageInterceptor,
  ChartSwitchingService,
  TooltipsService,
  SentryEnrichmentInterceptor,
} from '../core';
import { ClientBrandingService } from '@/app/core/client/client-branding.service';
import { FeatureFlagService } from '@/app/core/feature-flags/feature-flag.service';

@NgModule({
  providers: [
    FeatureFlagService,
    ActiveFilterService,
    RdoHttpService,
    ExcelExportService,
    AuthService,
    ProfileService,
    ClientProfileService,
    ClientBrandingService,
    ConfigService,
    RevenueChartHelperService,
    FormatService,
    QueryService,
    SvgService,
    ViewService,
    BreadcrumbService,
    ColumnDefinitionService,
    GridConfigService,
    RevenueMappingService,
    RentalGrowthChartService,
    RentalGrowthPanelEventService,
    DailyRatesChartService,
    HourlyRatesChartService,
    DollarUtilChartService,
    MonthlyRatesChartService,
    PhysicalUtilChartService,
    UnitsOnRentChartService,
    WeeklyRatesChartService,
    UnitsInFleetChartService,
    ChartExportService,
    MathService,
    TrialGuardService,
    FirestoreSettingsService,
    ErrorService,
    ChartSwitchingService,
    LocaleService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SentryEnrichmentInterceptor,
      multi: true,
    },
    TooltipsService,
    GridSortingService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreServicesModule {}
